import barba from '@barba/core';

function initResizeListener() {
  // Setup a timer
  let timeout;
  // Listen for scroll events
  window.addEventListener('resize', function(event) {
  	// If there's a timer, cancel it
  	if (timeout) {
  		window.cancelAnimationFrame(timeout);
  	}
    // Setup the new requestAnimationFrame()
  	timeout = window.requestAnimationFrame(function() {
      // Run our scroll function
  	});
  }, false);
}

function toggleSearch() {
  const rootEl = document.documentElement;
  rootEl.classList.toggle('search-is-active');

  if (rootEl.classList.contains('search-is-active')) {
    const searchInput = document.querySelector('#search-input')
    if (searchInput) {
      searchInput.focus();
    }
  }
}

function hideSearch() {
  const rootEl = document.documentElement;
  rootEl.classList.remove('search-is-active', 'search-is-searching');
  const searchForm = document.getElementById('search-form');
  searchForm.reset();
}

function ajaxSearch(e) {
  const rootEl = document.documentElement;
  rootEl.classList.add('search-is-searching');
  const searchForm = e.target;
  const action = searchForm.getAttribute('action');
  const formData = new FormData(searchForm);
  const queryString = new URLSearchParams(formData).toString();
  const fullUrl = `${window.location.origin}/${action}?${queryString}`;
  barba.go(fullUrl);
  hideSearch();
}

const search = {
  hideSearch: hideSearch,

  init() {
    const searchOpenButtons = Array.from(document.querySelectorAll('.js-search-open-button'));
    const searchForm = document.getElementById('search-form');
    initResizeListener();

    searchOpenButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        toggleSearch();
      })
    });

    document.addEventListener('click', function(e) {
      const clicked = e.target;
      const closeButton = clicked.closest('#close-search');
      if (closeButton) {
        hideSearch();
      } 
    })

    searchForm.addEventListener('submit', function(e) {
      e.preventDefault();
      ajaxSearch(e);
    });
  
    document.addEventListener('keydown', (e) => {
      const searchIsOpen = document.querySelector('.search-is-active')
      if (e.code === 'Escape' && searchIsOpen) {
        this.hideSearch();
      }
    });
  }
}

export default search;
